<template>
  <classic-container :title="$t('site-administration.no-site.title')">
    <p>{{ $t('site-administration.no-site.content') }}</p>
  </classic-container>
</template>

<script>
import ClassicContainer from '../classic-container'

export default {
  components: {
    ClassicContainer
  }
}
</script>
